import { useOnboarding } from '../../context/OnboardingContext';

const BackButton = () => {
  const { goToPreviousScreen, getCurrentScreen } = useOnboarding();

  const currentScreen = getCurrentScreen();
  
  if (currentScreen && currentScreen.showBackButton === false) {
    return null;
  }

  return (
    <button 
      className="back-button"
      onClick={goToPreviousScreen}
    >
      ‹
    </button>
  );
};

export default BackButton;
